module.exports = __webpack_public_path__ + "static/bg_cardboard_blue-11b8b7ab39c436a698b622f97044ba55.jpg";